import {createContext} from "react";
import {IDemandWLGenerator, IValidationErrors} from "../demandWLGenerator.interface";
import {IDemand} from "../../demands/demands/demand.interface";
import {ISeller} from "../../sellers/seller.interface";
import { IIntegration } from "../../integrations/base/integration.interface";
import { IAlertData } from "@leap4/frontend";

export const demandWLGeneratorContext = createContext({
    demandWLGenerator: {} as IDemandWLGenerator,
    setDemandWLGenerator: (demandWLGenerator: IDemandWLGenerator) => {    },
    demand: {} as IDemand,
    allDemands: [] as IDemand[],
    publishers: [] as ISeller[],
    runReport: (reportObj) => {    },
    reportData: {} as any,
    reportColumns: [] as any,
    isLoadingReport: false,
    validationErrors : {} as IValidationErrors,
    setTabIndex: (tabIndex: number) => {    },
    tabIndex: 0,
    runReportTemplate: (id:string) => {    },
    deleteReportTemplate: (id:string) => {    },
    updateReportTemplate: (id:string) => {    },
    reportTemplates: [] as IDemandWLGenerator[],
    saveOrUpdateWLGeneratorTemplate: (params:{id:string,data:any,ignoreValidation:boolean}) => {    },
    integrations: [] as IIntegration[],
    downloadCsv: async (id: string): Promise<string> => "",
    downloadBulkCsv: async (ids: string[]): Promise<Blob> => new Blob(),
    setAlert: (alert: IAlertData) => {},
})
